export const ENV_MODE = {
	STAGING: "staging",
	PRODUCTION: "production",
	UAT: "uat",
};

export const LANGUAGES = {
	EN: "en",
	ZH: "zh",
	VI: "vi",
	KM: "km",
};

export const COUNTRIES = {
	CN: "cn",
	VN: "vn",
	KH: "kh",
};

export const languages = [
	{
		name: "English",
		nameE: "English",
		flag: "/images/flag/flag_usa.png",
		key: LANGUAGES.EN,
	},
	{
		name: "中文",
		nameE: "Chinese",
		flag: "/images/flag/flag_china.png",
		key: LANGUAGES.ZH,
	},
	{
		name: "ភាសាខ្មែរ",
		nameE: "Cambodian",
		flag: "/images/flag/flag_cambodia.png",
		key: LANGUAGES.KM,
	},
];

//start banner
export const BANNER_STATUS = {
	ACTIVE: 1,
	INACTIVE: 2,
};

export const BANNER_TYPES = {
	CUSTOMER: "customer",
	MERCHANT: "merchant",
	BOTH: "both",
	CUSTOMER_WEB: "customer_web",
};

export const NOTIFICATION_SETTING_TYPE = {
	HAVE_SETTING: "have_setting",
	NO_SETTING: "no_setting",
};

export const ACTION_BANNER_TYPES = {
	LINK: "link",
	IN_APP: "in_app",
};

export const BANNER_ADS_POSITION = {
	HOMEPAGE: "homepage",
};

export const actionBannerTypes = [
	{
		name: "Link",
		value: ACTION_BANNER_TYPES.LINK,
	},
	{
		name: "In App",
		value: ACTION_BANNER_TYPES.IN_APP,
	},
];

export const bannerTypes = [
	{
		name: "Customer",
		value: BANNER_TYPES.CUSTOMER,
	},
	{
		name: "Merchant",
		value: BANNER_TYPES.MERCHANT,
	},
	{
		name: "Customer Web",
		value: BANNER_TYPES.CUSTOMER_WEB,
	},
	{
		name: "Both",
		value: BANNER_TYPES.BOTH,
	},
];

export const bannerTypesWithSettings = [
	{
		name: "Customer",
		value: BANNER_TYPES.CUSTOMER,
	},
	{
		name: "Merchant",
		value: BANNER_TYPES.MERCHANT,
	},
];

export const notificationSettingTypes = [
	{
		name: "Link to other page",
		value: NOTIFICATION_SETTING_TYPE.HAVE_SETTING,
	},
	{
		name: "HTML content",
		value: NOTIFICATION_SETTING_TYPE.NO_SETTING,
	},
];
export const valueTypes = [{ name: "Customer", value: BANNER_TYPES.CUSTOMER }];

export const bannerAdsPostion = [
	{
		name: "Homepage",
		value: BANNER_ADS_POSITION.HOMEPAGE,
	},
];

export enum NOTIFICATION_ROUTER_SETTING {
	IN_APP = "in_app",
	EXTERNAL_LINK = "external_link",
}

export const NOTIFICATION_ROUTER_SETTING_TYPES = [
	{ name: "In App", value: NOTIFICATION_ROUTER_SETTING.IN_APP },
	{ name: "External Link", value: NOTIFICATION_ROUTER_SETTING.EXTERNAL_LINK },
];

// end banner
export const CAR_STATUS_TYPE = {
	SOLD_BY_MERCHANT: "sold_by_merchant",
	SOLD_BY_LIBERTY: "sold",
	REJECT: "reject",
	PUBLISH: "publish",
	UNPUBLISH: "unpublish",
	PURCHASING: "purchasing",
	BLOCKED: "blocked",
	RENTING: "renting",
	APPROVED: "approved",
	PENDING: "pending",
	EXPIRED: "expired",
};

export const CAR_STATUS = [
	{ label: "Sold by merchant", value: CAR_STATUS_TYPE.SOLD_BY_MERCHANT },
	{ label: "Sold by Liberty", value: CAR_STATUS_TYPE.SOLD_BY_LIBERTY },
	{ label: "Rejected", value: CAR_STATUS_TYPE.REJECT },
	{ label: "Renting", value: CAR_STATUS_TYPE.RENTING },
	{ label: "Publish", value: CAR_STATUS_TYPE.PUBLISH },
	{ label: "Unpublish", value: CAR_STATUS_TYPE.UNPUBLISH },
	{ label: "Purchasing", value: CAR_STATUS_TYPE.PURCHASING },
	{ label: "Blocked", value: CAR_STATUS_TYPE.BLOCKED },
	{ label: "Pending", value: CAR_STATUS_TYPE.PENDING },
	{ label: "Expired", value: CAR_STATUS_TYPE.EXPIRED },
];

export const SALE_CAR_STATUS = [
	{ label: "Sold by merchant", value: CAR_STATUS_TYPE.SOLD_BY_MERCHANT },
	{ label: "Sold by Liberty", value: CAR_STATUS_TYPE.SOLD_BY_LIBERTY },
	{ label: "Publish", value: CAR_STATUS_TYPE.PUBLISH },
	{ label: "Unpublish", value: CAR_STATUS_TYPE.UNPUBLISH },
	{ label: "Purchasing", value: CAR_STATUS_TYPE.PURCHASING },
	{ label: "Expired", value: CAR_STATUS_TYPE.EXPIRED },
];

export const RENTAL_CAR_STATUS = [
	{ label: "Pending", value: CAR_STATUS_TYPE.PENDING },
	{ label: "Publish", value: CAR_STATUS_TYPE.PUBLISH },
	{ label: "Unpublish", value: CAR_STATUS_TYPE.UNPUBLISH },
	{ label: "Rejected", value: CAR_STATUS_TYPE.REJECT },
	{ label: "Renting", value: CAR_STATUS_TYPE.RENTING },
];

export const IMPORT_CAR_STATUS = [
	{ label: "Publish", value: CAR_STATUS_TYPE.PUBLISH },
	{ label: "Unpublish", value: CAR_STATUS_TYPE.UNPUBLISH },
];

export const CAR_TRANSMISSION = [
	{ label: "Manual", value: "manual" },
	{ label: "Automatic", value: "automatic" },
];

export const CAR_FUEL = [
	{ label: "Diesel", value: "diesel" },
	{ label: "Gasoline", value: "gasoline" },
	{ label: "Hybrid", value: "hybrid" },
	{ label: "Electric", value: "electric" },
];

export const CAR_COLOR = [
	{
		label: "Black",
		value: "black",
	},
	{
		label: "White",
		value: "white",
	},
	{
		label: "Gray",
		value: "gray",
	},
	{
		label: "Silver",
		value: "silver",
	},
	{
		label: "Blue",
		value: "blue",
	},
	{
		label: "Red",
		value: "red",
	},
	{
		label: "Brown",
		value: "brown",
	},
	{
		label: "Green",
		value: "green",
	},
	{
		label: "Orange",
		value: "orange",
	},
	{
		label: "Beige",
		value: "beige",
	},
	{
		label: "Purple",
		value: "purple",
	},
	{
		label: "Gold",
		value: "gold",
	},
	{
		label: "Yellow",
		value: "yellow",
	},
	{
		label: "Pink",
		value: "pink",
	},
];

export const CAR_DOORS = [2, 4, 5];

export const CAR_SEATS = ["2", "4", "5", "6", "7", "8", "9", "12", "15"];

export const CAR_BODY_TYPE = [
	{
		label: "Sedan",
		value: "sedan",
	},
	{
		label: "SUV",
		value: "suv",
	},
	{
		label: "Hatchback",
		value: "hatchback",
	},
	{
		label: "Pickup",
		value: "pickup",
	},
	{
		label: "Minivan",
		value: "minivan",
	},
	{
		label: "Coupe",
		value: "coupe",
	},
	{
		label: "Convertible",
		value: "convertible",
	},
	{
		label: "MPV",
		value: "mpv",
	},
	{
		label: "Sport",
		value: "sport",
	},
	{
		label: "City",
		value: "city",
	},
	{
		label: "Special Purpose",
		value: "special_purpose",
	},
	{
		label: "Wagon",
		value: "wagon",
	},
	{
		label: "VAN",
		value: "van",
	},
];

export const CAR_ORIGIN = [
	{ label: "Cambodia", value: "cambodia" },
	{ label: "USA", value: "usa" },
	{ label: "UK", value: "uk" },
	{ label: "Italy", value: "italy" },
	{ label: "France", value: "france" },
	{ label: "Mexico", value: "mexico" },
	{ label: "Japan", value: "japan" },
	{ label: "Korea", value: "korea" },
	{ label: "Malaysia", value: "malaysia" },
	{ label: "China", value: "china" },
	{ label: "India", value: "india" },
	{ label: "Spain", value: "spain" },
	{ label: "Germany", value: "germany" },
	{ label: "Thailand", value: "thailand" },
	{ label: "Indonesia", value: "indonesia" },
	{ label: "Sweden", value: "sweden" },
	{ label: "UAE", value: "united_arab_emirates" },
];

export const CAR_STATE = [
	{
		label: "New",
		value: "new",
	},
	{
		label: "Used",
		value: "used",
	},
];

export const CAR_TAX_TYPE = [
	{
		label: "Tax Paper",
		value: "tax_paper",
	},
	{
		label: "Plate Number",
		value: "plate_number",
	},
];

export const CAR_QUANTITY_CHECK = [
	{
		label: "Checked",
		value: true,
	},
	{
		label: "Uncheck",
		value: false,
	},
];

export const MAX_CAR_PHOTOS = 30;
export const MAX_COMMUNITY_POST_PHOTOS = 9;
export const MAX_STORE_PHOTOS = 12;
export const MAX_SIZE_VIDEO = 99 * 1024 * 1024;
export const MAX_SIZE_IMAGE_BASE64 = 200 * 1024;
export const MAX_SIZE_IMAGE_FIREBASE = 1024 * 1024;
export const MAX_SIZE_QC_INFORMATION_FILE = 2 * 1024 * 1024;
export const MAX_SIZE_IMAGE = 2 * 1024 * 1024;

export const MIN_YEAR_SEARCH = 1950;
export const MAX_YEAR_SEARCH = 2025;
export const DEFAULT_CURRENCY = "$";
export const ENGINE_POWER_UNIT = "BHP";
export const ENGINE_SIZE_UNIT = "L";
export const DATE_FORMAT = "YYYY-MM-DD";
export const HOUR_FORMAT = "HH:mm";
export const PERCENTAGE = "%";

// start client
export const CLIENT_TYPES = {
	CUSTOMER: "customer",
	MERCHANT: "merchant",
	BOTH: "both",
};

export const clientTypes = [
	{
		name: "Customer",
		value: CLIENT_TYPES.CUSTOMER,
	},
	{
		name: "Merchant",
		value: CLIENT_TYPES.MERCHANT,
	},
	{
		name: "Both",
		value: CLIENT_TYPES.BOTH,
	},
];
// end banner

// start content
export const CONTENT_TYPES = {
	LINK: "link",
	HTML: "html",
};

export const contentTypes = [
	{
		name: "link",
		value: CONTENT_TYPES.LINK,
	},
	{
		name: "html",
		value: CONTENT_TYPES.HTML,
	},
];
// end content
export const DEFAULT_PAGINATE_OPTION = ["5", "10", "20", "50"];

// stores
export const STORE_STATUS = {
	active: "enabled",
	inactive: "disabled",
};

export const COMMON_STATUS = {
	all: {
		label: "All",
		value: "all",
	},
	enable: {
		label: "Enable",
		value: "enable",
	},
	disable: {
		label: "Disable",
		value: "disable",
	},
	enabled: {
		label: "Enabled",
		value: "enabled",
	},
	disabled: {
		label: "Disabled",
		value: "disabled",
	},
	active: {
		label: "Active",
		value: "active",
	},
	inactive: {
		label: "Inactive",
		value: "inactive",
	},
	blocked: {
		label: "Blocked",
		value: "blocked",
	},
	publish: {
		label: "Publish",
		value: "publish",
	},
	unpublish: {
		label: "Unpublish",
		value: "unpublish",
	},
};

export const NUMBER_REGEX = /^\d+$/;

export const NOTIFICATION_TYPE = {
	created_car: "created_car",
	merchant_just_edited_information_of_a_car:
		"merchant_just_edited_information_of_a_car",
	staff_new_test_drive: "staff_new_test_drive",
	staff_cancel_test_by_customer: "staff_cancel_test_by_customer",
	customer_create_new_customer_request: "customer_create_new_customer_request",
	merchant_add_car_request: "merchant_add_car_request",
	merchant_add_service_request: "merchant_add_service_request",
	merchant_cancel_car_request: "merchant_cancel_car_request",
	merchant_cancel_service_request: "merchant_cancel_service_request",
	customer_register_collaborator: "customer_register_collaborator",
	staff_new_rent_appointment: "staff_new_rent_appointment",
	merchant_updated_rent_car: "merchant_updated_rent_car",
	merchant_created_rent_car: "merchant_created_rent_car",
	staff_customer_cancel_rent_appointment:
		"staff_customer_cancel_rent_appointment",
	merchant_completed_rental_purchase: "merchant_completed_rental_purchase",
	car_wash_merchant_created: "car_wash_merchant_created",
	car_wash_merchant_updated: "car_wash_merchant_updated",
	merchant_created_car_wash_post_to_staffs:
		"merchant_created_car_wash_post_to_staffs",
	merchant_created_voucher_to_staffs: "merchant_created_voucher_to_staffs",
	merchant_edited_voucher_to_staffs: "merchant_edited_voucher_to_staffs",
	merchant_update_car_store_to_staffs: "merchant_update_car_store_to_staffs",
	// Car loan request
	car_loan_request_created_to_staff: "car_loan_request_created_to_staff",
};

export const MAX_CAR_ADDED = 5;

export const BOOKING_CAR_STATUS = {
	CANCELED: "canceled",
	BOOKED: "booked",
};

export const NOTIFICATION_ADD_MEMBER_TYPE = {
	CREATE: "create",
	EDIT: "edit",
	PREVIEW: "preview",
	VIEW: "view",
};

export const MESSAGE_OVERLAPPED = {
	CODE: "duplicate_position_status_enable",
};

export const EXPIRED_SESSION_MESSAGE_KEY = "authenticationMessage";

// Contact support
export const CONTACT_SUPPORT_STATUS = {
	NEW: {
		key: "new",
		value: "New",
		colorTag: "#4096ff",
	},
	PROCESSING: {
		key: "processing",
		value: "Processing",
		colorTag: "#ffa940",
	},
	SOLVED: {
		key: "resolved",
		value: "Solved",
		colorTag: "#73d13d",
	},
};

export const SURVEY_STATUS = {
	ENABLED: {
		key: "enabled",
		value: "Enabled",
	},
	DISABLED: {
		key: "disabled",
		value: "Disabled",
	},
};
// End contact support

export const CAR_PRICE_FILTER_OPTIONS = [
	{
		key: "all",
		value: {
			min: 0,
			max: null,
		},
		label: "All",
	},
	{
		key: "lv1",
		value: {
			min: 0,
			max: 5000,
		},
	},
	{
		key: "lv2",
		value: {
			min: 5000,
			max: 10000,
		},
	},
	{
		key: "lv3",
		value: {
			min: 10000,
			max: 20000,
		},
	},
	{
		key: "custom",
		value: {
			min: 0,
			max: null,
		},
		label: "Custom",
	},
];

export const CAR_SORT_OPTIONS = [
	{
		label: "Newest Created",
		value: {
			sortColumn: "createdAt",
			order: "DESC",
		},
	},
	{
		label: "Oldest Created",
		value: {
			sortColumn: "createdAt",
			order: "ASC",
		},
	},
	{
		label: "Newest Updated",
		value: {
			sortColumn: "updatedAt",
			order: "DESC",
		},
	},
	{
		label: "Oldest Updated",
		value: {
			sortColumn: "updatedAt",
			order: "ASC",
		},
	},
	{
		label: "Price Low to High",
		value: {
			sortColumn: "price",
			order: "ASC",
		},
	},
	{
		label: "Price High to Low",
		value: {
			sortColumn: "price",
			order: "DESC",
		},
	},
	{
		label: "Views Low to High",
		value: {
			sortColumn: "additionalAttributes.view",
			order: "ASC",
		},
	},
	{
		label: "Views High to Low",
		value: {
			sortColumn: "additionalAttributes.view",
			order: "DESC",
		},
	},
];

// --- start affiliate transaction ---
export const AFFILIATE_TRANSACTION_STATUS = {
	PENDING: {
		key: "pending",
		value: "Pending",
		colorTag: "#4096ff",
	},
	VERIFIED: {
		key: "verified",
		value: "Verified",
		colorTag: "#73d13d",
	},
};

export const AFFILIATE_TRANSACTION_TYPE = {
	APPOINTMENT: {
		key: "appointment",
		value: "Appointment",
		colorTag: "#4096ff",
	},
	PURCHASE: {
		key: "purchase",
		value: "Purchase",
		colorTag: "#73d13d",
	},
};
// --- end affiliate transaction ---

export const CAR_MEDIA_RULE = {
	external: {
		maxLength: {
			value: 16,
			message: "Maximum upload 16 external photos",
		},
		minLength: {
			value: 1,
			message: "External photo is required",
		},
	},
	internal: {
		maxLength: {
			value: 14,
			message: "Maximum upload 14 internal photos",
		},
		minLength: {
			value: 1,
			message: "Internal photo is required",
		},
	},
	video: {
		required: {
			message: "Video is required",
		},
	},
};

export const CAR_TYPE: {
	[key: string]: {
		key: string;
		label: string;
	};
} = {
	sale: {
		key: "sale",
		label: "For sale",
	},
	rent: {
		key: "rent",
		label: "For rent",
	},
};

export const CAR_OWNER_TYPE: {
	[key: string]: {
		key: string;
		label: string;
	};
} = {
	merchant: {
		key: "merchant",
		label: "Merchant",
	},

	customer: {
		key: "customer",
		label: "Customer",
	},
};

export const TINY_EDITOR_API_KEY =
	process.env.REACT_APP_ENV === ENV_MODE.PRODUCTION
		? "n36hhnnsxgrazdfzh8g0qguka2x4jpq9fob0hwj9qceh3ifp" //prod - baonp@libertytechnology.co
		: //  ? "5h9x9ddmmfwpjrq92vrcahxu5k5q5azscwqutut6vt39uj5y" //prod - ngophongbao5@gmail.com
		  // : "x5r9pb1172onwoil0ltfycil6s7st896vshe779d7jdfqvne"; // dev or stag - baonp.blackwind@gmail.com
		  //: "qh0v024ugei4jrpi295qxicezzv5nhybbhijvwnkwgzlr3ui"; // dev or stag - ngophongbao2@gmail.com
		  "16b53ybkg3b3r4njuiqxbgyy9mf4szo5gxmmlq4ka81tx3k9"; // dev or stag - ngophongbao4@gmail.com

export const TRANSACTION_TYPE: {
	[key: string]: {
		key: string;
		label: string;
	};
} = {
	sale: {
		key: "sale",
		label: "Sales",
	},
	rent: {
		key: "rent",
		label: "Rental",
	},
	carWash: {
		key: "carWash",
		label: "Car care",
	},
};

export const CAR_RENTAL_TYPE: {
	[key: string]: {
		key: string;
		label: string;
	};
} = {
	"self-driving": {
		key: "self-driving",
		label: "Self-driving",
	},
	driver: {
		key: "driver",
		label: "Driver",
	},
};

// Start loyalty voucher
export const LOYALTY_VOUCHER_TYPE = {
	CASH: {
		key: "cash",
		value: "Cash",
		colorTag: "#4096ff",
	},
	REWARD: {
		key: "reward",
		value: "Reward",
		colorTag: "#ffa940",
	},
	DISCOUNT: {
		key: "discount",
		value: "Discount",
		colorTag: "#50C878",
	},
	TICKET: {
		key: "ticket",
		value: "Ticket",
		colorTag: "#273c75",
	},
};

export const VOUCHER_DISCOUNT_TYPE = {
	CASH: {
		key: "cash",
		value: "Cash",
		colorTag: "#4096ff",
	},
	PERCENTAGE: {
		key: "percentage",
		value: "Percentage",
		colorTag: "#ffa940",
	},
};
// End loyalty voucher

// Start loyalty voucher code
export const LOYALTY_VOUCHER_CODE_TYPE = {
	AUTO_GENERATE: {
		key: "auto",
		value: "Auto generate",
	},
	IMPORT: {
		key: "import",
		value: "Import",
	},
};

export const VOUCHER_CODE_STATUS = {
	AVAIABLE: "available",
	USED: "used",
	EXPIRED: "expired",
};

export const VOUCHER_CODE_TRANSACTION_TYPE = {
	SENT: "sent",
	SELF_REDEEM: "self_redeem",
	CAMPAIGN_REWARD: "campaign_reward",
};
// End loyalty voucher code

export const KIND_OF_SERVICE = {
	DEFAULT: "default",
	CHECK_CAR: "check_car",
	INSURANCE: "insurance",
};

export const PRICE_FILTER_TYPE = {
	DAY: "pricePerDay",
	WEEK: "pricePerWeek",
	MONTH: "pricePerMonth",
};

export const DIRECTION_TYPE = {
	HORIZONTAL: "horizontal",
	VERTICAL: "vertical",
};
